<template>

    <v-card class="theme-card category-details p-relative"
        :class="{
            'active' : opened,
            'selected' : selected
        }">
        <v-container v-show="opened">
            <v-row>
                <v-col cols="12" class="text-center">
                    <div class="text weight-500 font-alt size-small color-black-lighten-1">
                        Les clients qui se sont rendus dans votre établissement
                    </div>
                    <div class="text weight-500 font-alt size-small color-purple-alt">
                        {{description}}
                    </div>
                    <div class="text weight-500 font-alt size-small color-black-lighten-1">
                        seront dans ce segment.
                    </div>
                    <div class="mt-3">
                        <v-btn class="theme-btn filled-purple-alt shape-rounded size-small" @click="opened = false">Fermer</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <v-container v-show="!opened" @click="select" :class="{'selectable' : selectable}">
            <v-row justify="end">
                 <div class="open-icon">
                <v-btn icon small @click.stop.prevent="opened = true">
                    <v-icon small>more_horiz</v-icon>
                </v-btn>
            </div>
            </v-row>
            <v-row 
                class="my-1"
                justify="center"
            >
                <v-col sm="4" lg="4" md="12" xl="4" 
                    class="text-center"
                    
                >
                    <div class="category-color-container"
                        :class="{
                            'color-green' : color === 'green',
                            'color-orange' : color === 'orange',
                            'color-purple' : color === 'purple',
                            'color-blue' : color === 'blue',
                            'color-green-dark' : color === 'green-dark',
                            'color-pink' : color === 'pink'
                        }"/>
                </v-col>
                 <v-col 
                    sm="8" lg="8" md="12" xl="8" 
                    class="text-center p-relative"
                >
                    <div  
                        class="category-label"
                        :class="{
                            'pb-8 mt-4' : $vuetify.breakpoint.sm,
                            'pb-6 pr-2' : $vuetify.breakpoint.md,
                            'pr-3' : $vuetify.breakpoint.lgAndUp
                        }"
                    >
                        {{label}}
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-card>

</template>

<script type="text/javascript">

    export default {
        name: 'category-details',
        components: {

        },
        props : {
            color : {
                type : String,
                default : 'green'
            },
            code : {
                type : String,
                default : null
            },
            label : {
                type : String,
                default : ''
            },
            description : {
                type : String,
                default : ''
            },
            selectable : {
                type : Boolean,
                default : false
            }
        },
        data () {
            return {
                opened : false,
                selected : false
            }
        },
        methods : {
            select () {
                if (this.selectable) {
                    this.selected = !this.selected;
                    this.$emit('click', this.code);
                }
            }
        }
    }

</script>

<style lang="scss">
    
    .category-details {

        .selectable {
            cursor: pointer;
        }

        &.selected {
            border : 3px solid $green-lighten-1;
            box-shadow: 0 0 24px 0 rgba(80, 50, 206, 0.29) !important;
        }

        transition-duration : 0.2s;

        &.active {
            border : 2px solid $orange-lighten-1;
        }

        .open-icon {
            // position : absolute;
            top: 10px;
            right : 10px;
        }

        .category-label {
            display: flex;
            justify-content: center;
            height: 48px;
            position: absolute;
            flex-direction: column;
            top: 0px;
        }

        .category-color-container {
            display: inline-block;
            width : 26px;
            height : 26px;
            border-radius : 50%;
            &.color-green {
                background-color : $green-lighten-1;
            }
            &.color-orange {
                background-color : $orange-lighten-1;
            }
            &.color-purple {
                background-color : $purple-alt;
            }
            &.color-blue {
                background-color : $blue-base;
            }
            &.color-green-dark {
                background-color : $green-dark;
            }
            &.color-pink {
                background-color : $pink-base;
            }

        }

    }

</style>


